import React, { useState, useMemo } from "react";
import HoverModalButton from "./HoverModalButton";
import InputSlider from "./InputSlider";
import { useGlobalState } from "../hooks/useGlobalState";

interface HandlesModalButtonProps {
	type: string;
	displayValue: any;
	onUpdate: any;
	disabled?: boolean;
}

export const HandlesModalButton = ({
	type,
	displayValue,
	onUpdate,
	disabled,
}: HandlesModalButtonProps) => {
	const { keysHeld } = useGlobalState();

	const handleSliderChange = (vals: any) => {
		onUpdate(vals);
	};

	let x, y;
	if (type === "Out") {
		x = displayValue.x1;
		y = displayValue.y1;
	} else if (type === "In") {
		x = 1 - displayValue.x2;
		y = 1 - displayValue.y2;
	}

	const [yVal, setYValue] = useState(y);
	const [xVal, setXValue] = useState(x);
	const memoizedDisplayValue = useMemo(() => displayValue, [displayValue]);

	function handleYValueChange(e: React.ChangeEvent<HTMLInputElement>) {
		setYValue(parseFloat(e.target.value));
		let vals = displayValue;
		if (keysHeld.shift) {
			vals.y1 = parseFloat(e.target.value);
			vals.y2 = 1 - parseFloat(e.target.value);
		} else if (type === "Out") {
			vals.y1 = parseFloat(e.target.value);
		} else if (type === "In") {
			vals.y2 = 1 - parseFloat(e.target.value);
		}
		handleSliderChange(vals);
	}
	function handleXValueChange(e: React.ChangeEvent<HTMLInputElement>) {
		setXValue(parseFloat(e.target.value));
		let vals = displayValue;
		if (keysHeld.shift) {
			vals.x1 = parseFloat(e.target.value);
			vals.x2 = 1 - parseFloat(e.target.value);
		}
		if (type === "Out") {
			vals.x1 = parseFloat(e.target.value);
		} else if (type === "In") {
			vals.x2 = 1 - parseFloat(e.target.value);
		}
		handleSliderChange(vals);
	}

	return (
		<HoverModalButton
			disabled={disabled}
			onClick={() => ""}
			label={`${Math.round(
				type === "Out"
					? memoizedDisplayValue.x1 * 100
					: (1 - memoizedDisplayValue.x2) * 100
			)}%`}
		>
			<InputSlider
				label={`${type} Y`}
				min={-0.5}
				max={1.5}
				step={0.01}
				value={
					type === "Out" ? memoizedDisplayValue.y1 : 1 - memoizedDisplayValue.y2
				}
				onChange={handleYValueChange}
			/>
			<InputSlider
				label={`${type} X`}
				min={0}
				max={1}
				step={0.01}
				value={
					type === "Out" ? memoizedDisplayValue.x1 : 1 - memoizedDisplayValue.x2
				}
				onChange={handleXValueChange}
			/>
		</HoverModalButton>
	);
};
